<template>
  <div>
    <breadcrumb-bar
      :crumbs="[{name:'Groups'},{name:'Messaging', link:'Messaging Home'},{name:'Send a Message'}]"></breadcrumb-bar>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md" style="width: 100%">
                  <span class="caption-subject bold uppercase">Messaging</span>

                  <span class="pull-right options-gear" @click.prevent="columnsModalShow()" v-if="user.access >= 5"><i class="icon-settings right"></i></span>
                </div>
                <div v-if="step === 2" class="selected-info">
                  {{ selected.length }} {{ participantSingularName.toLowerCase() }}<span v-if="selected.length > 1">s</span> selected
                  {{ selected.length }} {{ participantSingularName.toLowerCase() }}<span v-if="selected.length > 1">s</span> selected
                </div>
              </div>

              <groups-forms-columns id="groups-forms-columns" context="groups_messaging" @confirmed="saveParticipantColumns"/>

              <div class="portlet-body">
                <div v-if="step === 1">

                  <div class="alert alert-warning" role="alert">
                    <strong>Alert!</strong> Only {{ participantPluralName.toLowerCase() }} with a Phone Number entry display in the below table.
                  </div>

                  <form role="form" class="form-horizontal" @submit.prevent="search">
                    <div class="form-group form-md-line-input has-warning">
                      <div class="col-md-12">
                        <div class="input-group">
                          <div class="input-group-control input-icon">
                            <i class="fa fa-search"></i>
                            <input type="text" placeholder="Type to search..." class="form-control"
                                   v-model="searchQuery">
                            <div class="form-control-focus"></div>
                          </div>
                          <span class="input-group-btn btn-right">
                        <button type="submit" data-style="expand-left"
                                class="btn green mt-ladda-btn ladda-button search-btn-submit-pd">
                          <span class="ladda-label">Search</span>
                        </button>
                      </span>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div class="vue-good-table" v-if="(participants.length > 0) || filterActive">
                    <vue-good-table
                      :columns="columns"
                      :rows="participants"
                      :pagination-options="{
                      enabled: true,
                        perPageDropdown: [10, 20, 50, 100, 200, 500],
                        dropdownAllowAll: true,
                        perPage: this.serverParams.perPage
                      }"
                      mode="remote"
                      :totalRows="totalRecords"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"

                    >
                      <template slot="table-column" slot-scope="props">
                        <label class="mt-checkbox mt-checkbox-outline" v-if="props.column.label == 'All'">
                          <input type="checkbox" v-model="selectAll"/>
                          <span></span>
                        </label>
                        <span v-else>
                          {{ props.column.label }}
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <template v-if="props.column.field=='before'">
                          <label class="mt-checkbox mt-checkbox-outline">
                            <input type="checkbox" :value="props.row.id" @click="selectRow"
                                   :checked="selected.includes(props.row.id)"/>
                            <span></span>
                          </label>
                        </template>
                        <template v-else>{{ props.formattedRow[props.column.field] }}</template>
                      </template>

                    </vue-good-table>
                  </div>
                  <div class="not-found-results" v-else>
                    <h4>Sorry, no search results were found.</h4>
                    <h5>Search Suggestions:</h5>
                    <ul>
                      <li>Check your spelling</li>
                      <li>Search by {{ participantSingularName }} Name, System ID or Organization ID</li>
                    </ul>
                  </div>
                  <router-link tag="button" class="btn green pull-left" :to="{ name: 'Messaging Home' }">
                    Back
                  </router-link>
                  <button class="btn green pull-right" @click.stop="messageForm()" v-if="selected.length > 0">
                    Next
                  </button>
                </div>
                <div v-if="step === 2">
                  <div class="form-group">
                    <textarea class="form-control"
                              placeholder="Type a message here..."
                              v-model="messageBody"></textarea>
                    <small class="pull-right">{{ charactersRemaining }} Characters Remaining</small>
                    <div class="clearfix"></div>
                  </div>
                  <button class="btn green pull-left" @click.stop="selectParticipants()">
                    Back
                  </button>
                  <button data-style="expand-left"
                          class="btn green pull-right mt-ladda-btn ladda-button groups-btn-submit"
                          @click.prevent="submit()">
                    <span class="ladda-label">Send</span>
                  </button>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import Spinner from '@/components/Spinner'
import VueFormRender from '@/components/formbuilder/VueFormRender'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import GroupsFormsColumns from "../../components/modals/GroupsFormsColumns";
import {HTTP} from '@/http-common';
import participantDisplayName from '@/mixins/participantDisplayName';

export default {
  mixins: [
    participantDisplayName
  ],
  data() {
    return {
      searchQuery: '',
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      messageBody: '',
      charactersRemaining: 255,
      maximumCharacters: 255,
      filterActive: false
    }
  },
  components: {
    'breadcrumb-bar': Breadcrumbs,
    'vue-spinner': Spinner,
    'vue-form-render': VueFormRender,
    GroupsFormsColumns

  },
  created() {
    this.SET_COLUMNS([]);
    this.setGroupsStep(1);
    this.getParticipantList();
    this.setGroupsSelectedAll([]);
  },
  computed: {
    ...mapGetters({
      step: 'getGroupsStep',
      forms: 'getGroupsFormsInOrder',
      form: 'getGroupsForm',
      participants: 'getGroupsParticipants',
      selected: 'getGroupsSelected',
      loadingSearch: 'getGroupsLoadingSearch',
      totalRecords: 'getGroupsParticipantsResultsCount',
      user: 'getUser',
      serverColumns: 'getGroupsColumns'
    }),
    selectAll: {
      get: function () {
        return this.participants.length !== 0 && (this.participants.length === this.selected.length)
      },
      set: function (value) {
        if (value) {
          let items = []
          this.participants.forEach(function (item) {
            items.push(item.id)
          })
          this.setGroupsSelectedAll(items)
        } else {
          this.setGroupsSelectedAll([])
        }
      },
    },
    columns() {
      let serverColumns = [...this.serverColumns];
      serverColumns.unshift(
        {
          label: 'All',
          field: 'before',
          sortable: false
        }
      )

      serverColumns.map(item => {
        if (item.hasOwnProperty('key') && item.key.startsWith('cf')) {
          item.sortable = false;
        }
      })

      return serverColumns;
    }
  },
  methods: {
    ...mapActions({
      setGroupsStep: 'SET_GROUPS_STEP_ACTION',
      getGroupsFormsAction: 'GET_GROUPS_FORMS_ACTION',
      getGroupsFormAction: 'GET_GROUPS_FORM_ACTION',
      getGroupsParticipantsAction: 'GET_GROUPS_PARTICIPANTS_ACTION',
      updateGroupsSelected: 'UPDATE_GROUPS_SELECTED_ACTION',
      setGroupsSelectedAll: 'SET_GROUPS_SELECTED_ALL_ACTION',
      sendMassMessage: 'SUBMIT_MASS_MESSAGES_MESSAGE_ACTION'
    }),
    ...mapMutations([
      'SET_COLUMNS'
    ]),
    getInitial(data) {
      let init = {};
      let dataN = JSON.parse(JSON.stringify(data));
      dataN.map(el => {
        init[el.name] = el['hide'];
      });
      console.log(init);
      return JSON.parse(JSON.stringify(init));
    },
    selectParticipants(id) {
      this.getGroupsFormAction(id);
      this.setGroupsStep(1)
    },
    messageForm() {
      this.setGroupsStep(2)
    },
    submit() {
      let context = Ladda.create(document.querySelector('.groups-btn-submit'));
      this.sendMassMessage({data: this.createPayload(), context});
    },
    selectRow(event) {
      this.updateGroupsSelected(parseInt(event.srcElement.value))
    },
    search() {
      this.getGroupsParticipantsAction({
          keyword: this.searchQuery,
          notdismissed: true,
          ignorewithemptystatus: true,
          context: 'groups_messaging'
        }
      )
    },
    getParticipantList() {
      this.getGroupsParticipantsAction({
        notdismissed: true,
        for_messaging: true,
        ignorewithemptystatus: true,
        limit: this.serverParams.perPage,
        current_page: this.serverParams.page,
        sort_by: this.serverParams.sort.field,
        sort_order: this.serverParams.sort.type,
        columns_filter: this.serverParams.columnFilters,
        context: 'groups_messaging'
      });
    },
    createPayload() {
      return {
        participant_ids: this.selected,
        body: this.messageBody
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.getParticipantList();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage, page: 1});
      this.getParticipantList();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        },
      });
      this.getParticipantList();
    },

    onColumnFilter(params) {
      this.filterActive = true;
      this.updateParams(params);
      this.getParticipantList();
    },

    columnsModalShow() {
      $('#groups-forms-columns').modal('show');
    },

    saveParticipantColumns(columns) {
      HTTP.post(`participant-directory-columns/save`, {
        columns: JSON.stringify(columns),
        context: 'groups_messaging'
      })
        .then(response => {
          this.SET_COLUMNS([]);
          this.getParticipantList()
        }).catch(err => {
        console.log(err);
      });
    },
  },
  watch: {
    loadingSearch(newValue) {
      let el = document.querySelector('.search-btn-submit-pd');
      if (el !== null) {
        const button = Ladda.create(el);
        newValue === true ? button.start() : button.stop()
      }
    },
    messageBody(newValue, oldValue) {
      if (newValue.length > this.maximumCharacters) {
        this.messageBody = oldValue
      }
      this.charactersRemaining = this.maximumCharacters - newValue.length;
    }
  }
}
</script>

<style scoped>
.alert-warning {
  background: #fffae5;
  border-color: #fff1a2;
  color: #8c730e;
}

.vue-good-table {
  margin-bottom: 20px;
}

.form-name {
  padding-top: 0;
  margin-top: 0;
  margin-bottom: 20px;
}

.selected-info {
  float: right;
  line-height: 18px;
  margin: 10px 0;
  color: #666;
}

.list-group-item {
  margin-bottom: 20px;
}

.options-gear {
  display: inline-block;
  padding: 3px 5px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// SendMessage.vue?e0a34f38